module.exports = __webpack_public_path__ + "img/5.ecedb2be.png";